export default __webpack_public_path__ + "static/media/viewaction.b70ad4d4.png";